/* eslint-disable */
import { Link, useParams } from "react-router-dom";

/**
 * @description Renders the common header for the company details section.
 * @param {string} moduleName - The name of the currently active module to highlight the corresponding link.
 * @returns {JSX.Element} The JSX code for the company details common header.
 */
const CompanyDetailsCommonHeader = ({ moduleName }) => {
  // Retrieve route parameters using the useParams hook from react-router-dom.
  const params = useParams();

  // Define navigation links in a JSON array for better scalability and maintainability.
  const navLinks = [
    {
      to: `/admin/companies/info/${params.id}`,
      label: "General Info", //"General Info"
      module: "info",
    },
    {
      to: `/admin/companies/contracts/${params.id}`,
      label: "Contracts", //"Contracts"
      module: "contracts",
    },
    {
      to: `/admin/companies/teammembers/${params.id}`,
      label: "Company Members", //"Company Members"
      module: "teammembers",
    },
    {
      to: `/admin/companies/peoples/${params.id}`,
      label: "Peoples", //"Peoples"
      module: "peoples",
    },
    {
      to: `/admin/companies/goals/${params.id}`,
      label: "Goals", //"Peoples"
      module: "goals",
    },
  ];

  return (
    // Main container for the inner menu with a white background and a subtle shadow.
    <div className="inner-menu-container bg-white shadow-sm">
      <div className="container-fluid px-lg-5">
        {/* Unordered list for the secondary menu, designed to be flexible and responsive. */}
        <ul className="nav secondary-menu mw-100 flex-nowrap gap-xl-5 flex-fill fs-sm fw-semibold text-center border-0 text-nowrap overflow-auto">
          {/* Map through the navLinks array to dynamically generate each navigation item. */}
          {navLinks.map((link) => (
            <li className="nav-item flex-fill" key={link.module}>
              {/* Link component from react-router-dom for client-side navigation. */}
              <Link
                to={link.to}
                className={`d-block text-black px-2 px-sm-3 py-3 py-sm-4 position-relative ${
                  moduleName === link.module && "active"
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CompanyDetailsCommonHeader;
